import { render } from "./WatchesRandom.vue?vue&type=template&id=17942098"
import script from "./WatchesRandom.vue?vue&type=script&lang=js"
export * from "./WatchesRandom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__